
import { defineComponent, PropType, reactive } from 'vue'

// @ui-kit
import NewButton from '@/ui-kit/NewButton/index.vue'

// @types
import { CourierReportInfo } from '@/new-services/types/couriers'

// @new-services
import couriersAPI from '@/new-services/couriers.service'

// @composable
import useNotifications from '@/common/composable/useNotifications'

import { formatDateFromBackend } from '@/common/helpers/formatDate'

export default defineComponent({
    components: {
        NewButton,
    },
    props: {
        column: {
            type: Object as PropType<{ name: string; key: string }>,
            required: true,
        },
        row: {
            type: Object as PropType<CourierReportInfo>,
            required: true,
        },
        index: {
            type: Number,
            default: 0,
        },
        parentIndex: {
            type: Number,
            default: 0,
        },
        parentRow: {
            type: Object as PropType<any>,
            required: true,
        },
        expanded: {
            type: Boolean,
            default: false,
        },
        dateFilter: {
            type: String,
            default: null,
        },
    },
    emits: ['closed'],
    setup(props, { emit }) {
        const notifications = useNotifications()

        const state = reactive({
            is_loading: false,
        })

        const closeDay = async () => {
            const answer = confirm(`Вы действительно хотите завершить день ${props.row.date}?`)
            if (!answer) return

            try {
                state.is_loading = true

                const response = await couriersAPI.closeDay(props.parentRow.id, {
                    date: props.row.date,
                })
                const errors = response.data.data.errors

                if (!errors) {
                    notifications.notify({
                        type: 'success',
                        title: `День ${props.row.date} завершен`,
                    })
                }

                emit('closed', {
                    index: props.index,
                    parentIndex: props.parentIndex,
                    undeliveredInvoices: response.data.data.errors,
                })
            } catch (error) {
                console.error(error)
                notifications.notifyError({
                    error,
                    title: `При завершении дня ${props.row.date} произошала ошибка`,
                })
            } finally {
                state.is_loading = false
            }
        }

        return {
            state,
            closeDay,
            formatDateFromBackend,
        }
    },
})
